var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexChart',{attrs:{"type":"bar","height":"350","options":_vm.chartOptionsComputed,"series":_vm.seriesComputed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }